import type React from 'react';
import { FormattedDateTime, Table } from 'components';
import { useTablePagination } from 'hooks/useTablePagination';
import type { ColumnsType } from 'antd/lib/table';
import { AsyncJobDetails } from './AsyncJobDetails';
import type { JobsCardTab } from '../enums/JobsCardTab';
import { useCardAsyncJobs } from '../hooks/useCardAsyncJobs';
import type { AsyncJobData } from '../queries/getAsyncJobListData';

const COLUMNS: ColumnsType<AsyncJobData> = [
  {
    title: 'Name',
    dataIndex: ['data', 'name'],
    key: 'name',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'status',
    render: createdAt => <FormattedDateTime date={createdAt} />,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: '',
    key: 'actions',
    width: 70,
    render: (_, { data, fail_reason }) => {
      return <AsyncJobDetails data={data} fail_reason={fail_reason} />;
    },
  },
];

export const AsyncJobsTable: React.VFC<{ activeJobsTab: JobsCardTab }> = ({ activeJobsTab }) => {
  const { paginationOptions } = useTablePagination(0, 'jobs', 1, 20);

  const { data, loading } = useCardAsyncJobs(activeJobsTab, paginationOptions);

  const asyncJobs = data?.jobs?.data ?? [];

  return (
    <Table<AsyncJobData>
      columns={COLUMNS}
      dataSource={asyncJobs}
      loading={loading}
      pagination={{
        ...paginationOptions,
        total: data?.jobs?.meta.pagination.total ?? 0,
      }}
      rowKey="id"
      scroll={{ y: 800 }}
    />
  );
};
